import React, {Component} from 'react';
import {connect} from 'react-redux'
// import DropdownMenu from 'react-dd-menu';
// import "react-dd-menu/dist/react-dd-menu.css";
import {Menu, SubMenu, MenuItem, MenuButton} from '@szhsin/react-menu';
import {AppLanguages, locale,setLocale,getLocale} from '../locale/AppLocale'
import {NavLink} from 'react-router-dom'
import * as authActions from '../actions/authActions';
import {Link} from 'react-router-dom';
import AppMainMenu from './AppMainMenu/index';
import AppSubMenu from './AppMainMenu/AppSubMenu';

class MainMenu extends Component {
    constructor() {
        super();
        this.menuItems = [];

        this.state = {
            isMenuOpen: false,
            isFinancialMenuOpen: false,
            isLanguagesMenuOpen: false,
            languages: AppLanguages
        };

    }


    toggle = () => {
        this.setState({isMenuOpen: !this.state.isMenuOpen});
    };

    toggleFinancial = () => {
        this.setState({isFinancialMenuOpen: !this.state.isFinancialMenuOpen});
    };

    toggleLanguages = () => {
        this.setState({isLanguagesMenuOpen: !this.state.isLanguagesMenuOpen});
    };

    close = () => {
        this.setState({isMenuOpen: false});
    };
    closeFinancial = () => {
        this.setState({isFinancialMenuOpen: false});
    };

    closeLanguagesMenu = () => {
        this.setState({isLanguagesMenuOpen: false});
    };

    changeLocale = (value) => {
        setLocale(value);
    }
    getBusinessElement(business, isButton = false) {
        return (
            <span className="businesses-list--business">
                <img src={business.logo} alt="" width="20"/>
                <span>{business.name_ar}</span>
                {isButton ? (<span className="arrow-down">&#709;</span>) : ('')}
            </span>
        );
    }

    getCurrentBusiness() {
        let business = this.props.auth.business;
        if ((!business || typeof business === 'undefined' || typeof business.slug === 'undefined') && this.props.auth.businesses.length) {
            business = this.props.auth.businesses[0];
        }
        return business;
    }

    getOptions() {
        return {
            textAlign: 'right',
            align: 'left',
            className: 'user-menu-list',
            isOpen: this.state.isMenuOpen,
            close: this.close.bind(this),
            toggle: <button className="main-menu--toggle" type="button"
                            onClick={this.toggle.bind(this)}>{this.props.auth.logged_in ? (this.getBusinessElement(this.getCurrentBusiness(), true)) : locale.get('login')}</button>,
        };
    }

    render() {
        let bussinessLinks = [];
        let financialMenu = null;
        let languagesMenu = null;

        if (this.props.match.path !== '/404') {

            bussinessLinks = [
                <li key="m-1">
                    <NavLink
                        className="main-menu--item"
                        to={`/${this.props.match.params.businessSlug}/orders`}>{locale.get('manage_orders')}</NavLink>
                </li>,
                <li key="m-2">
                    <NavLink
                        className="main-menu--item"
                        to={`/${this.props.match.params.businessSlug}/manage`}>{locale.get('manage_products_offers')}</NavLink>
                </li>,
                <li key="m-3">
                    <NavLink
                        className="main-menu--item"
                        to={`/${this.props.match.params.businessSlug}/search/categories`}>{locale.get('add_new_product')}</NavLink>
                </li>
                // <li key="m-3">
                //     <NavLink
                //         className="main-menu--item"
                //         to={`/${this.props.match.params.businessSlug}/search`}>{locale.get('add_new_product')}</NavLink>
                // </li>
            ];
            if (this.props.auth.business.can_create_invoice) {
                bussinessLinks.push(<li key="m-0">
                    <NavLink
                        className="main-menu--item"
                        to={`/${this.props.match.params.businessSlug}/invoice`}>{locale.get('invoices')}</NavLink>
                </li>)
            }
            const financialMenuOption = {
                textAlign: 'right',
                align: 'right',
                className: 'menu-list main-menu__sub-menu',
                isOpen: this.state.isFinancialMenuOpen,
                close: this.closeFinancial.bind(this),
                toggle: <button className="main-menu--toggle" type="button"
                                onClick={this.toggleFinancial.bind(this)}>
                    <span className="businesses-list--business">
                        <span>{locale.get('financial')}</span>
                        <span className="arrow-down">&#709;</span>
                    </span>
                </button>,
            };

            const languagesMenuOption = {
                textAlign: 'right',
                align: 'right',
                className: 'menu-list main-menu__sub-menu',
                isOpen: this.state.isLanguagesMenuOpen,
                close: this.closeLanguagesMenu.bind(this),
                toggle: <button className="main-menu--toggle" type="button"
                                onClick={this.toggleLanguages.bind(this)}>
                    <span className="businesses-list--business">
                        <span>{getLocale().short_name}</span>
                        <span className="arrow-down">&#709;</span>
                    </span>
                </button>,
            };

            financialMenu = <li>
                <AppSubMenu {...financialMenuOption} closeOnInsideClick={false}>
                    <li>
                        <NavLink
                            className="main-menu--item"
                            onClick={(e) => {
                                this.toggleFinancial(e);
                            }}
                            to={`/${this.props.match.params.businessSlug}/financial/account-summary`}>{locale.get('financial_account_summary')}</NavLink>
                    </li>

                    <li>
                        <NavLink
                            className="main-menu--item"
                            onClick={(e) => {
                                this.toggleFinancial(e);
                            }}
                            to={`/${this.props.match.params.businessSlug}/financial/transactions`}>{locale.get('financial_transactions')}</NavLink>
                    </li>

                    <li>
                        <NavLink
                            className="main-menu--item"
                            onClick={(e) => {
                                this.toggleFinancial(e);
                            }}
                            to={`/${this.props.match.params.businessSlug}/financial/bank`}>{locale.get('manage_bank')}</NavLink>
                    </li>
                </AppSubMenu>
            </li>
            languagesMenu = <li>
                <AppSubMenu {...languagesMenuOption} closeOnInsideClick={false}>

                    {this.state.languages.map((lang, index) => {
                        return lang.is_active && <li key={`lang-item-${lang.code}`}>
                            <NavLink
                                className="main-menu--item"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.changeLocale(lang.code);
                                    this.toggleLanguages();
                                    window.location.reload(true);
                                }}
                                to={`/#${lang.code}`}>
                                {lang.short_name}
                            </NavLink>
                        </li>
                    })}

                </AppSubMenu>
            </li>
        }

        return (
            this.props.auth.logged_in && <AppMainMenu className="main-menu" isOpen={true}>
                {financialMenu}
                {bussinessLinks}
                {languagesMenu}

                <li>
                    <AppSubMenu {...this.getOptions()} closeOnInsideClick={false}>
                        {
                            this.props.auth.businesses.length && <li className="businesses-list">
                                <AppMainMenu isOpen={true}>
                                    {this.props.auth.businesses.map((business, index) => {
                                        return this.renderBusinessMenuItem(business)

                                    })}
                                </AppMainMenu>
                            </li>

                        }
                            <li>
                                <Link className={`main-menu--item`} to={`#`} onClick={(e) => {
                                    e.preventDefault();
                                    this.props.logout();
                                }}>{locale.get('logout')}</Link>
                            </li>
                    </AppSubMenu>
                </li>


                {/*<li>*/}
                {/*    <Link className={`main-menu--item`} to={`#`} onClick={(e) => {*/}
                {/*        e.preventDefault();*/}
                {/*        this.props.logout();*/}
                {/*    }}>{locale.get('logout')}</Link>*/}
                {/*</li>*/}
            </AppMainMenu>
        )
    }

    renderBusinessMenuItem(business) {
        return (
            <li key={business.id}
            >
                <NavLink to={`/${business.slug}`}
                         className={`main-menu--item ${business.id === this.props.auth.business.id ? `active` : ``}`}
                         onClick={() => this.props.selectBusiness(business)}
                >{this.getBusinessElement(business)}</NavLink></li>
        );
    }

}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth
    }
};

// Maps actions to props
const mapDispatchToProps = (dispatch) => {
    return {
        loginByHash: (params) => dispatch(authActions.loginByHash(params)),
        logout: () => dispatch(authActions.logout()),
        selectBusiness: (business) => dispatch(authActions.selectBusiness(business))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu);
